// (c) 2026 Owl Consultations. All rights reserved.
// Proprietary and confidential — licensed use only.

/**
 * Full-page host for the IG Dosing Calculator (I-980). The calculator is the same
 * self-contained static page (/dosing-calculator.html) used by the floating launcher;
 * here it lives under its own nav item in the CareRx section. Route is gated by
 * RequirePerm (rx.read) + RequireModule ('calculator') in App.tsx.
 */
export default function DosingCalculatorPage() {
  return (
    <div style={wrap}>
      <iframe src="/dosing-calculator.html" title="IG Dosing Calculator" style={frame} />
    </div>
  )
}

const wrap: React.CSSProperties = {
  display: 'flex', flexDirection: 'column', width: '100%',
}
const frame: React.CSSProperties = {
  width: '100%', height: 'calc(100dvh - 96px)', minHeight: 560, border: 'none',
  display: 'block', background: 'var(--color-bg,#FBFAF8)',
}
